import Swiper, { Navigation, Pagination, Lazy, Autoplay} from 'swiper';
Swiper.use([Navigation, Pagination, Lazy, Autoplay]);

export default function setQuotationSwiper() {
  const quotationSlider = new Swiper('[data-quotation] .swiper', {
    slidesPerView: 1,
    spaceBetween: 10,
    speed: 1000,
    watchOverflow: true,
    centerInsufficientSlides: true,
    autoplay: true,
    loop: true,
    lazy: {
      enabled: true, // Ativa o Lazy Loading
      loadPrevNext: true, // Carrega imagens adjacentes
      loadOnTransitionStart: true, // Carrega ao iniciar a transição
      loadPrevNextAmount: 2, // Número de imagens carregadas adjacentes
    },
    preloadImages: false, // Impede o pré-carregamento de todas as imagens
    pagination: {
      el: '[data-quotation] .swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
    navigation: {
      nextEl: '[data-quotation] .swiper-button-next',
      prevEl: '[data-quotation] .swiper-button-prev', 
    },
    breakpoints: {
      991: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 24,
      },
    },
  });
}
